<template>
	<c-dialog ref="dialog" :title="title" width="560">
		<c-form ref="form" column="2" vertical unit-width="100%">
			<c-form-item v-if="isWarehouse" label="质检仓名称" required colspan="2">
				<c-input name="description" placeholder="请输入质检仓名称"></c-input>
			</c-form-item>
			<c-form-item label="省市区" required colspan="2">
				<c-region province-name="province" city-name="city" county-name="district"></c-region>
			</c-form-item>
			<c-form-item label="详细地址" required colspan="2">
				<c-input name="address" placeholder="请输入详细地址"></c-input>
			</c-form-item>
			<c-form-item label="联系部门" required>
                <c-select name="manage_dept_id" async @search="searchDepartment" v-model="manage_dept_id"
                          :value-data="selectedDepartment" @change="changeDepartment" required></c-select>
			</c-form-item>
			<c-form-item label="联系人" required >
                <c-select ref="manageUserSelect" name="manage_user_id" async @search="searchUser" :value-data="selectedUser" required :disabled="!manage_dept_id || manage_dept_id==0"></c-select>
			</c-form-item>
			<c-form-item v-if="isWarehouse" :label="false" colspan="2">
				<div class="form-tip">联系部门、联系人将作为该质检仓线上采购单的默认采购部门和默认采购人</div>
			</c-form-item>
			<c-form-item v-if="isWarehouse" label="操作部门" required>
                <c-select name="operate_dept_id" async @search="searchDepartment" v-model="operate_dept_id"
                          :value-data="selectedOperateDepartment" @change="changeOperateDepartment" required></c-select>
			</c-form-item>
			<c-form-item v-if="isWarehouse" label="操作人" required>
                <c-select ref="operateUserSelect" name="operate_user_id" async @search="searchOperateUser" :value-data="selectedOperateUser" required :disabled="!operate_dept_id || operate_dept_id==0"></c-select>
			</c-form-item>
			<c-form-item v-if="isWarehouse" :label="false" colspan="2">
				<div class="form-tip">操作部门、操作人将作为该质检仓线上采购单的默认创建部门和默认创建人</div>
			</c-form-item>
			<c-form-item v-if="!isWarehouse" label="是否默认">
				<c-checkbox v-model="formData.is_default">设为默认地址</c-checkbox>
			</c-form-item>
			<c-form-item label="是否可用">
				<c-checkbox v-model="formData.is_enable">启用</c-checkbox>
			</c-form-item>
		</c-form>

		<template #button>
			<c-button size="dialog" color="main" @click="save">保存</c-button>
			<c-button size="dialog" @click="close">取消</c-button>
		</template>
	</c-dialog>
</template>

<script>
	export default {
		name: 'addressEditDialog',

		data() {
			return {
				formData: {
					id: '',
					address_type: 1,
					description: '',
					province: '',
					city: '',
					district: '',
					address: '',
					name: '',
					phone: '',
					is_default: false,
					is_enable: true,
				},
                selectedDepartment:[],
                selectedUser:[],
                manage_dept_id:0,
                selectedOperateDepartment:[],
                selectedOperateUser:[],
                operate_dept_id:0,
                operate_user_id:0
			}
		},

		computed: {
			title() {
				return this.formData.id ? (this.isWarehouse ? '编辑回收质检仓' : '编辑地址') : (this.isWarehouse ? '新建回收质检仓' : '新增地址');
			},

			isWarehouse() {
				return this.formData.address_type == 3;
			}
		},

		methods: {
            /*******搜索部门*****************/
            searchDepartment(keyword, resolve){
                this.request({
                    url:'/system/options',
                    data: {
                        options_code:'DEPARTMENT',
                        keyword:keyword
                    },
                    success:data => {
                        resolve(data);
                    }
                })
            },
            changeDepartment(){
                //切换联系部门后原联系人不再适用，清空待重选
                //直接对组件实例set，不能用form.set：其内部对c-region分支会无条件调set({})连带清空省市区
                this.$refs.manageUserSelect.set('');
            },
            changeOperateDepartment() {
                //切换操作部门后原操作人不再适用，清空待重选
                this.$refs.operateUserSelect.set('');
            },
            /************搜索用户*******************************/
            searchUser(keyword, resolve) {
                this.request({
                    url: '/system/options',
                    data: {
                        user_type: 1,
                        department_id: this.manage_dept_id,
                        options_code: 'SYSUSER',
                        keyword: keyword
                    },
                    success: data => {
                        resolve(data);
                    }
                })
            },
            /************搜索操作人（质检仓）*******************************/
            searchOperateUser(keyword, resolve) {
                this.request({
                    url: '/system/options',
                    data: {
                        user_type: 1,
                        department_id: this.operate_dept_id,
                        options_code: 'SYSUSER',
                        keyword: keyword
                    },
                    success: data => {
                        resolve(data);
                    }
                })
            },
			open(data, addressType) {
                this.selectedUser = [];
                this.selectedDepartment = [];
                this.selectedOperateUser = [];
                this.selectedOperateDepartment = [];
                this.manage_dept_id = '';
                this.operate_dept_id = '';
				if (data) {
					this.formData = Object.assign({}, this.getDefaultForm(), data, {
						address_type: addressType || data.address_type || 1,
						is_default: data.is_default == 1,
						is_enable: data.is_enable !== 0
					});
                    this.manage_dept_id = data.manage_dept_id || '';
                    this.operate_dept_id = data.operate_dept_id || '';
                    if (data.manage_user_id && data.name){
                        this.selectedUser = [{
                            name:data.name,
                            value:data.manage_user_id
                        }]
                    }
                    if (data.manage_dept_id && data.manage_dept_name){
                        this.selectedDepartment = [{
                            name:data.manage_dept_name,
                            value:data.manage_dept_id
                        }]
                    }
                    if (data.operate_user_id && data.operate_user_name){
                        this.selectedOperateUser = [{
                            name:data.operate_user_name,
                            value:data.operate_user_id
                        }]
                    }
                    if (data.operate_dept_id && data.operate_dept_name){
                        this.selectedOperateDepartment = [{
                            name:data.operate_dept_name,
                            value:data.operate_dept_id
                        }]
                    }
				} else {
					this.formData = this.getDefaultForm();
					this.formData.address_type = addressType || 1;
				}
				this.$nextTick(() => {
					this.$refs.form && this.$refs.form.set(this.formData);
				});
				this.$refs.dialog.open();
			},

			close() {
				this.$refs.dialog.close();
			},

			getDefaultForm() {
				return {
					id: '',
					address_type: 1,
					description: '',
					province: '',
					city: '',
					district: '',
					address: '',
					name: '',
					phone: '',
					is_default: false,
					is_enable: true
				}
			},

			save() {
				var rule = {
					province: '请选择省',
					city: '请选择市',
					district: '请选择区',
					address: '请输入详细地址',
                    manage_dept_id: '请选择联系部门',
                    manage_user_id: '请选择联系人'
				};
				if (this.isWarehouse) {
					rule.description = '请输入质检仓名称';
					rule.operate_dept_id = '请选择操作部门';
					rule.operate_user_id = '请选择操作人';
				}
				this.$refs.form.submit({
					url: this.formData.id ? '/sys_saas/address/edit' : '/sys_saas/address/save',
					rule,
					dataFormatter: data => {
						var result = {
							...data,
							id: this.formData.id,
							address_type: this.formData.address_type,
							is_default: this.formData.is_default ? 1 : 0,
							is_enable: this.formData.is_enable ? 1 : 0
						};
						//操作部门、操作人仅质检仓维护，未选择时不传对应字段，后端落空
						if (!result.operate_dept_id) {
							delete result.operate_dept_id;
						}
						if (!result.operate_user_id) {
							delete result.operate_user_id;
						}
						return result;
					},
					success: (data, msg) => {
						this.$message({message: '保存成功', type: 'success'});
						this.close();
						this.$emit('success');
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.form-tip {
		line-height: 18px;
		font-size: 12px;
		color: #999;
	}
</style>
